import { categories, siteNav } from "@/mocks/chiGuaData";

export default function FooterSection() {
  return (
    <footer className="border-t border-background-300/70 bg-accent-100/40 text-foreground-700">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 font-heading text-lg font-black text-background-50">
                瓜
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-lg font-black tracking-tight text-foreground-950">
                  吃瓜反差
                </span>
                <span className="text-[10px] font-medium tracking-[0.22em] text-foreground-500">
                  CONTRAST ARCHIVE
                </span>
              </div>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed">
              把「立人设期」与「翻车后」的公开言行、精修物料与同场生图并排整理，
              专注塌房瞬间、人设崩塌、滤镜破碎与偶像失格的理性复盘。
            </p>
            <p className="mt-4 flex items-center gap-2 text-xs font-semibold text-accent-800">
              <i className="ri-verified-badge-fill" />
              仅整理公开可查证物料 · 不信谣不传谣
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-bold text-foreground-950">站内栏目</h4>
            <ul className="mt-3 space-y-2">
              {categories.map((c) => (
                <li key={c.id}>
                  <a href="#contrast" className="text-sm transition-colors hover:text-primary-700">
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-bold text-foreground-950">快速导航</h4>
            <ul className="mt-3 space-y-2">
              {siteNav.slice(1).map((n) => (
                <li key={n.id}>
                  <a href={`#${n.id}`} className="text-sm transition-colors hover:text-primary-700">
                    {n.label}
                  </a>
                </li>
              ))}
              <li>
                <a href="#contact" className="text-sm transition-colors hover:text-primary-700">
                  纠错与投稿
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-950">关于我们</h4>
            <p className="mt-3 text-sm leading-relaxed">
              一间以反差对照为手法的吃瓜内容编辑部，只做并排、不做判决。
            </p>
            <a
              href="mailto:hello@chiguafancha.example"
              className="mt-3 inline-flex items-center gap-2 rounded-md bg-foreground-950 px-3.5 py-2 text-xs font-semibold text-background-50 transition-colors hover:bg-foreground-800"
            >
              <i className="ri-mail-send-line" />
              hello@chiguafancha.example
            </a>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-3 border-t border-background-300/60 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center">
          <p>
            本站内容基于公开可查证资料整理，仅作娱乐观察与舆论复盘，不构成对任何个人的人格评价。
          </p>
          <p className="flex items-center gap-4">
            <span>© 2026 吃瓜反差官网 · 让围观更清醒</span>
            <a href="#top" className="inline-flex items-center gap-1 font-semibold text-primary-700 hover:underline">
              回到顶部
              <i className="ri-arrow-up-line" />
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}